var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-select", {
    attrs: {
      filterable: "",
      clearable: "",
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.branchId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "branchId", $$v);
      },
      expression: "listQuery.branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), !_vm.isSalesExecutiveAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Branch Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["mappedAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "mappedAdmin.id", $$v);
      },
      expression: "listQuery['mappedAdmin.id']"
    }
  }, _vm._l(_vm.salesExecutiveAdmins, function (salesExecutive) {
    return _c("el-option", {
      key: salesExecutive.id,
      attrs: {
        label: salesExecutive.fullName,
        value: salesExecutive.id
      }
    });
  }), 1) : _vm._e(), !_vm.isZonalManagerAdmin() ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Select Zonal Manager"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery["zonalAdmin.id"],
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "zonalAdmin.id", $$v);
      },
      expression: "listQuery['zonalAdmin.id']"
    }
  }, _vm._l(_vm.zonalManagerAdmins, function (zonalAdmin) {
    return _c("el-option", {
      key: zonalAdmin.id,
      attrs: {
        label: zonalAdmin.fullName,
        value: zonalAdmin.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.listLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: _vm.$t("dealersDispatch.dealer")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: _vm.$t("dealersDispatch.agent")
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.agentId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "agentId", $$v);
      },
      expression: "listQuery.agentId"
    }
  }, _vm._l(_vm.agentList, function (agent) {
    return _c("el-option", {
      key: agent.id,
      attrs: {
        label: agent.name,
        value: agent.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      multiple: "",
      placeholder: "Range"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.rangeId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "rangeId", $$v);
      },
      expression: "listQuery.rangeId"
    }
  }, _vm._l(_vm.rangeList, function (range) {
    return _c("el-option", {
      key: range.id,
      attrs: {
        label: range.name,
        value: range.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "States"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "stateId", $$v);
      },
      expression: "listQuery.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(state.name))])]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.listQuery.stateId > 0,
      clearable: "",
      filterable: "",
      placeholder: "Cities"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.cityId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "cityId", $$v);
      },
      expression: "listQuery.cityId"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.id
      }
    });
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]), _c("span", {
    staticClass: "filter-item"
  }, [_c("span", {
    staticStyle: {
      "margin-right": "8px"
    }
  }, [_vm._v("Amount")]), _c("el-switch", {
    attrs: {
      "active-text": "Impact Value"
    },
    on: {
      change: _vm.handleValueModeChange
    },
    model: {
      value: _vm.showImpactValue,
      callback: function ($$v) {
        _vm.showImpactValue = $$v;
      },
      expression: "showImpactValue"
    }
  })], 1)], 1) : _vm._e(), _vm._isAdminRoles() ? _c("el-checkbox", {
    on: {
      change: _vm.onCheckboxChange
    },
    model: {
      value: _vm.listQuery.excludeBranches,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "excludeBranches", $$v);
      },
      expression: "listQuery.excludeBranches"
    }
  }, [_vm._v(" Uncheck to include branch ")]) : _vm._e(), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "350px",
      prop: "dealerName",
      label: "Dealer",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_c("b", [_vm._v(_vm._s(scope.row.dealerName))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "agentName",
      label: "Agent"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_c("b", [_vm._v(_vm._s(scope.row.aName))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "stateName",
      label: "State"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("span", [_c("b", [_vm._v(_vm._s(scope.row.stateName))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "oliveSeries",
      label: "Olive Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "oliveSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "ouraSeries",
      label: "Oura Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "ouraSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "deluxeSeries",
      label: "Deluxe Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "deluxeSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "mcbSeries",
      label: "MCB Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "mcbSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "lyfeSeries",
      label: "Lyfe Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "lyfeSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "vivaSeries",
      label: "Viva Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "vivaSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "curvySeries",
      label: "Curvy Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "curvySeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "iconnectSeries",
      label: "I-Connect Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "iconnectSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "epicSeries",
      label: "Epic Series",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "epicSeries")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "totalSales",
      label: "Total Sales",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: _vm.displayValue(scope.row, "totalSales")
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Branch Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Branch Manager")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Zonal Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Zonal Manager")) + " ")];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };